import React, { Component } from 'react';
import PropTypes from 'prop-types';

class KioskSeriesContentContainer extends Component {
    render() {
        return(
            <div className="kiosk__series-picker__content">
                {this.props.children}
            </div>
        )
    }
}

export default KioskSeriesContentContainer